module.exports = __webpack_public_path__ + "img/shp.393798ff.png";